<template>
  <div class="h-screen flex flex-col bg-gradient-to-br from-inboxbg via-rdeoverview to-inboxbg overflow-hidden">
    <div class="grid grid-cols-8 gap-4 p-4 flex-grow min-h-0">
      <rdemenumobile
        @close="sidebarOpened = false"
        :sidebaropened="sidebarOpened"
      />

      <div class="hidden lg:block col-span-2 h-full min-h-0 overflow-y-auto">
        <rdemenu></rdemenu>
      </div>

      <div class="col-span-8 lg:col-span-6 rounded-lg flex flex-col min-h-0">
        <div
          class="flex-shrink-0 flex sm:justify-between justify-center items-center w-full bg-white border border-gray-100 rounded-lg shadow-sm mb-4"
        >
          <button
            type="button"
            class="block lg:hidden sm:pl-4 pl-2"
            @click="sidebarOpened = true"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
          <rdeheader></rdeheader>
        </div>

        <div class="bg-mainsection flex-grow min-h-0 overflow-y-auto">
          <router-view v-slot="slotProps">
            <transition name="route" mode="out-in">
              <component :is="slotProps.Component"></component>
            </transition>
          </router-view>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div
      class="footer flex-shrink-0 flex h-14 bg-white text-expressgray border-t-2 rounded shadow-2xl items-center justify-center p-3"
    >
      <p class="text-xs">
        &#169; {{ new Date().getFullYear() }} Powered by
        <a href="https://tizeti.com" target="_blank">Tizeti Network Limited</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "RdeOverView",
  data() {
    return {
      sidebarOpened: false,
    };
  },
};
</script>

<style scoped>
/* Add your custom styles here if needed */
</style>
